import BehaviorAction from './behavior_action';

export default class BehaviorCancelEventAction extends BehaviorAction {
	_reason;

	constructor(props = {}) {
		super(props);
	}

	get reason() {
		return this._reason;
	}

	set reason(value) {
		this._reason = value;
	}
}
